module.exports = __webpack_public_path__ + "media/images/boxes/shop-box143-1112ecea04bb70c5d3355d8b5d6c7807.png";